export function collectionSlider() {
    const slider = $(".slider-collection");

    let arrow = '<svg width="25" height="40" viewBox="0 0 25 40" xmlns="http://www.w3.org/2000/svg"><polyline ' +
        'fill="none" stroke="#d9d2d0" stroke-width="2" points="4.002,38.547 22.527,20.024 4,1.5 "></polyline></svg>';

    slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        appendDots: $('.dots'),
        infinite: true,
        mobileFirst: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        adaptiveHeight: true,
        prevArrow: '<button type="button" class="slick-prev">' + arrow + '</button>',
        nextArrow: '<button type="button" class="slick-next">' + arrow + '</button>',
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            },
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/collection-slider.js